import React from "react";
import DisclaimerSection from "../components/Disclaimer/Disclaimer.tsx";
import MetaComponent from "../components/CommonComponents/MetaComponent.tsx";
const Disclaimer = () => {
  return (
    <div>
       <MetaComponent
        title="Disclaimer"
        desc=""
        keywords=""
      />
      <DisclaimerSection />
    </div>
  );
};

export default Disclaimer;
